import { Eye, Sparkles, ArrowLeft, ChevronRight } from 'lucide-react'
import { useNavigate } from 'react-router-dom'

/**
 * DemoBanner — barra prominente que aparece encima de cualquier página
 * cuando el usuario está navegando una consultancy con is_demo=true.
 *
 * Comunica claramente:
 *  - "Estás viendo un plan ejemplo"
 *  - CTA para volver a su propio dashboard
 *  - CTA para suscribirse y crear el suyo
 */
export default function DemoBanner({ onSubscribe }) {
  const navigate = useNavigate()
  return (
    <div className="rounded-2xl bg-gradient-to-r from-accent-500/15 via-amber-50 to-cream-100 border-2 border-accent-500/40 px-5 py-4 mb-6 shadow-sm">
      <div className="flex items-center justify-between gap-4 flex-wrap">
        <div className="flex items-start gap-3 min-w-0 flex-1">
          <div className="w-10 h-10 rounded-xl bg-accent-500 flex items-center justify-center flex-shrink-0">
            <Eye size={18} className="text-brand-900" />
          </div>
          <div className="min-w-0">
            <p className="text-sm font-bold text-gray-900 flex items-center gap-2 flex-wrap">
              Estás viendo un plan ejemplo
              <span className="text-[10px] font-bold uppercase tracking-wider bg-accent-500 text-brand-900 px-2 py-0.5 rounded-full">
                DEMO
              </span>
            </p>
            <p className="text-xs text-gray-600 mt-0.5 leading-relaxed max-w-xl">
              Navega libremente — todo lo que ves está pre-llenado para que veas el resultado
              completo. Cuando estés listo, suscríbete para construir el tuyo.
            </p>
          </div>
        </div>
        <div className="flex items-center gap-2 flex-shrink-0">
          <button
            onClick={() => navigate('/caja')}
            className="inline-flex items-center gap-1.5 text-xs font-semibold text-gray-700 hover:bg-white px-3 py-2 rounded-lg transition-colors"
          >
            <ArrowLeft size={13} /> Volver a mi dashboard
          </button>
          {onSubscribe && (
            <button
              onClick={onSubscribe}
              className="inline-flex items-center gap-1.5 bg-brand-800 hover:bg-brand-900 text-white text-xs font-bold px-4 py-2 rounded-lg transition-colors shadow-sm"
            >
              <Sparkles size={13} /> Suscribirme
              <ChevronRight size={13} />
            </button>
          )}
        </div>
      </div>
    </div>
  )
}
